module.exports = __webpack_public_path__ + "img/hydralytica.7aa79397.svg";